<template>
  <div v-if='gotData'>            
    <div class="row">   
        <div class="col-xs-12 col-sm-12 col-md-12" >            
            <div class='carPhotosList'>                
                <div v-for='itemsDetail in ItemsDetails' >
                    <router-link v-bind:to="'/view/carForsaleview/' +  itemsDetail.id" tag='a' class="thumbnail">
                        <img  class='thumbnailScreen' v-bind:src="$http.options.root + imageFolderPath + itemsDetail.image_name" alt="Imagen" ><br>
                        <span class='carDetail' >                        
                            <span >{{ itemsDetail.car_brand_name }}  </span>
                            <span >{{ itemsDetail.car_model_name }}  </span>
                            <span >{{ itemsDetail.model_year }}      </span><br>                            
                            <span style="color: black" >{{itemsDetail.currency_name}}$ {{ itemsDetail.offerprice | AddCommasToNumber }}</span>
                        </span>
                    </router-link>
                </div>                
            </div>
        </div>     
    </div>      
    <div>
        <Pagination v-bind:pagesInfo='pagesInfo' ></Pagination>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../main';
export default {  
  data: function () {     
    return {
       gotData:false,
       ItemsDetails: [],       
       imageFolderPath: '/uploads/',
       itemsPerPage: 12,       
       pagesInfo:[],
       carsCount:0,     
       offset:0,
       brand:0,
       model:0,  
       year:0,  
    }
  },
  mounted: function () {            
    this.updateParams();
    this.getItemsDetails();
    this.getTotalCarsForSale();
  },
  watch: { // whenever question changes, this function will run        
    $route () {        
        this.getItemsDetails();        
        this.getTotalCarsForSale();            
    }
  },
  methods: {
    updateParams : function() {
        if(this.$route.params.offset)
            this.offset = this.$route.params.offset;    
        else
            this.offset = 0;

        if(this.$route.params.brand)
            this.brand = this.$route.params.brand;
        else
            this.brand = 0;

        if(this.$route.params.model)
            this.model = this.$route.params.model;    
        else
            this.model = 0;

        if(this.$route.params.year)
            this.year = this.$route.params.year; 
        else
            this.year = 0;
    },
    getItemsDetails: function() {                      
        
        this.updateParams();        

        var callUrl = 'api/carforsalelist/' + this.itemsPerPage + '/' + this.offset;     

        if(this.brand > 0)                        
            callUrl += '/brand/' + this.brand;        

        if(this.model > 0)            
            callUrl += '/model/' + this.model;        

        if(this.year > 0)            
            callUrl += '/year/' + this.year;        
                                  
        this.$http.get(callUrl).then(response => {   

            this.ItemsDetails = response.body.map(obj =>{                                                                             
                return obj;
            });                                    
                        
            this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },      
    getTotalCarsForSale: function() {     

        var callUrl = 'api/carforsalelist/gettotalcarsforsale';     

        if(this.brand > 0)                        
            callUrl += '/brand/' + this.brand;        

        if(this.model > 0)            
            callUrl += '/model/' + this.model;        

        if(this.year > 0)            
            callUrl += '/year/' + this.year;        
        
        this.$http.get(callUrl).then(response => {   
            var numOfPages = response.body.map(obj =>{                                                                                                                                                                                         
                return Math.ceil(obj.count / this.itemsPerPage);
            });                     

            this.pagesInfo = [];
            for(var i = 0; i < numOfPages; i++){      
                if(this.brand > 0) 
                    this.pagesInfo.push('/view/' + (i*this.itemsPerPage) + '/brand/' + this.brand);
                else if(this.model > 0) 
                    this.pagesInfo.push('/view/' + (i*this.itemsPerPage) + '/model/' + this.model);
                else if(this.year > 0) 
                    this.pagesInfo.push('/view/' + (i*this.itemsPerPage) + '/year/'  + this.year);
                else
                    this.pagesInfo.push('/view/' + (i*this.itemsPerPage));
            }
                                                           
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },      
 
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped>    

   @media screen and (min-width: 0px) {  
        .thumbnailScreen {        
            background-size:contain;
            width:100%;
            height:100%;
        }

        .carDetail {            
            font-size: 36px;
            color: #2D80C7;
            text-align: center;
        }
   }

  @media screen and (min-width: 981px) {  
        .thumbnailScreen {        
            background-size:contain;
            width:200px;
            height:200px;
        }

        .carDetail {            
            font-size: 18px;
            color: #2D80C7;
            text-align: center;
        }
   }

   

   .carViewTitle {
        font-weight: bold;
        color: #2D80C7;
        font-size: 36px;        
   }

    .carViewOfferPrice{
        font-weight: bold;
        color: red;
        font-size:1.7em;        
    }

    .carViewPrice{
        font-weight: bold;
        color:red;
        font-size:1.7em;        
    }
    
    ul {
        list-style: none;
    }

    .carPhotosList div {
       float: left;       
       margin: 5px;       
    }

    .boldClass {
       font-weight: bold;
    }

    .datosGenerales {
        font-weight:500;
        color: red;
        font-size:1.7em;        
    }

</style>



// WEBPACK FOOTER //
// CarForSaleAllView.vue?13dc1df9